<template>
  <Gallery
    :images="[
      require('@/assets/img/IMG_9710-1200w.jpg'),
      require('@/assets/img/IMG_5082-1200w.jpg'),
      require('@/assets/img/IMG_0404-1200w.jpg'),
    ]"
  />
</template>

<script>
import Gallery from '@/components/Gallery.vue'

export default {
  name: 'Home',

  components: {
    Gallery
  }
}
</script>
